import { render, staticRenderFns } from "./ColorModuleTitle.vue?vue&type=template&id=6ff76582&scoped=true"
import script from "./ColorModuleTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorModuleTitle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorModuleTitle.vue?vue&type=style&index=0&id=6ff76582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff76582",
  null
  
)

export default component.exports